// Layout constants
export const NAVBAR_HEIGHT = 72; // Navbar height in pixels
